import React, { useState } from 'react';
import Search from '../icons/Search.png';
import gamedata from '../pages/gamedata';
function SearchBarbare() {
  const [searchQuery, setSearchQuery] = useState('');

  function handleInputChange(event) {
    setSearchQuery(event.target.value);
  }

  function handleSubmit(event) {
    event.preventDefault();
    window.location.href = `/search?q=${searchQuery}`;
  }

  return (
    <>
    <form  className='form-games-search' onSubmit={handleSubmit}>

        <input placeholder={"  Search " +gamedata.length+" games"}className="input-search"type="text" value={searchQuery} onChange={handleInputChange} />        <button className='submitsearch' type="submit"><img alt="Search"className='searchimg'src={Search}/> </button>
    </form>
  </>
  );
}

export default SearchBarbare;
